import Axios from "axios";

export const SelectCaisse = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/Caisse?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "CAISSE_SELECT", payload: response.data });
    });
  };
};
